export const INSPECTION_GROUP_UNLABELED_COLOR = '#FFFFFF'
